import { render, staticRenderFns } from "./TextStats.vue?vue&type=template&id=611ddd7b&scoped=true&"
import script from "./TextStats.vue?vue&type=script&lang=js&"
export * from "./TextStats.vue?vue&type=script&lang=js&"
import style0 from "./TextStats.vue?vue&type=style&index=0&id=611ddd7b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "611ddd7b",
  null
  
)

export default component.exports